import * as actionTypes from './actionTypes';
import axios from 'axios';

export const authStart = () => {
    return({
        type: actionTypes.AUTH_START,
    });
}

export const authSuccess = (data) => {
    return({
        type: actionTypes.AUTH_SUCCESS,
        twofaMethod: data.twofaMethod,
        token: data.token,
        userId: data.userId,
        caseId: data.caseId,
        newAccount: data.newAccount,
        typeOfAccount: data.type,
        verified: data.verified
    });
}

export const updateVerify2CodeToTrueAction = () => {
    
    return({
        type: actionTypes.UPDATE_VERIFY_2_CODE_TO_TRUE_ACTION,
        twofa: true
    });
}

export const recoverPasswordSuccess = () => {
    return({
        type: actionTypes.RECOVER_PASSWORD_SUCCESS,
    });
}

export const recoverPasswordFail = () => {
    return({
        type: actionTypes.RECOVER_PASSWORD_FAIL,
    });
}

export const changePasswordSuccess = () => {
    return({
        type: actionTypes.CHANGE_PASSWORD_SUCCESS,
    });
}

export const changePasswordFail = () => {
    return({
        type: actionTypes.CHANGE_PASSWORD_FAIL,
    });
}

export const authError = (error) => {
    return({
        type: actionTypes.AUTH_FAIL,
        error: error,
    });
}

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpirationDate');
    localStorage.removeItem('caseId');
    localStorage.removeItem('twofa');
    // window.testOn();
    return({
        type: actionTypes.AUTH_LOGOUT,
    });
}

export const checkAuthTimeout = (expirationTime) => {  
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    }
}

export const setAuthRedirect = (path) => {  
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path,
    }
}

export const authSuccessOnTryLogin = (newAccount) => {  
    return({
        type: actionTypes.AUTH_SUCCESS_ON_TRY_LOGIN,
        newAccount: newAccount,
    });
}

export const checkAuthState = (newAccount) => {  
    return dispatch => {
        const data = {
            token: localStorage.getItem('token'),
            caseId: localStorage.getItem('caseId'),
        }
        if (!data.token){
            dispatch(logout());
        }
        else {
            const tokenExpirationDate = new Date(localStorage.getItem('tokenExpirationDate'));
            if(tokenExpirationDate > new Date()){
                dispatch(authSuccessOnTryLogin(newAccount)); //fetch userId maybe later from api or store it in localStorage
                dispatch(checkAuthTimeout((tokenExpirationDate.getTime() - new Date().getTime()) / 1000));
            }
            else{
                dispatch(logout());
            }
        }
    }
}

export const updateVerify2CodeToTrue = () => {
    return (dispatch) => {
        console.log('in updateVerify2CodeToTrue')
        localStorage.setItem('twofa', true);
        console.log('dispatching updateVerify2CodeToTrueAction')
        dispatch(updateVerify2CodeToTrueAction());
    }
}

export const auth = (username, password, method = 'email', autologin = false) => {
    console.log('in auth in actions autologin', autologin)
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/login`;
    const authData = {
        username: username,
        password: password,
        method: method
    };
    console.log(url);
    return (dispatch) => {
        dispatch(authStart());
        axios.post(url, {
            ...authData
        })
        .then((response) => {
            // console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }

            if (response.data.type == 'paymentSkip'){
                localStorage.setItem('skipToken', response.data.token);
                localStorage.setItem('skipUniqueId', response.data.uniqueId);
                alert('Thank you for using HKAS. Payments will be automatically skipped in this browser for new cases.');
                window.location.reload();
            }
            else{
                console.log('login auth')
                console.log(JSON.stringify(response.data))
                const respTokenExpiresIn = 86400; //todo: retreive this from api in sec
                const expirationDate = new Date((new Date().getTime() + respTokenExpiresIn * 1000));
                console.log('Login response data: '+JSON.stringify(response))
                localStorage.setItem('token', response.data.uniqueId); //todo: retreive this from api
                localStorage.setItem('tokenExpirationDate', expirationDate);
                localStorage.setItem('typeOfAccount', response.data.type);
                if(response.data.caseId){
                    localStorage.setItem('caseId', response.data.caseId);
                }

                if(autologin){
                    console.log('autologin 1')
                    localStorage.setItem('twofa', true);
                    console.log('autologin 2')
                }
                
                dispatch(authSuccess(response.data));
                dispatch(checkAuthTimeout(respTokenExpiresIn));
            }

            
        })
        .catch((error) => {
            console.log(error);
            dispatch(authError(error));
        });
    };
}

export const recoverPassword = (email) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/recoverPassword`;
    var lang = localStorage.getItem('language')
    const authData = {
        email: email,
        lang: lang
    };
    console.log(url);
    return (dispatch) => {
        dispatch(authStart());
        axios.post(url, {
            ...authData
        })
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                dispatch(recoverPasswordFail());
            }
            else if (response.data === 'success'){
                dispatch(recoverPasswordSuccess());
            }
            
        })
        .catch((error) => {
            console.log(error);
            dispatch(authError(error));
        });
    };
}

export const changePassword = (uniqueId, currentPassword, newPassword) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/changePassword`;
    const authData = {
        uniqueId: uniqueId,
        currentPassword: currentPassword,
        newPassword: newPassword
    };
    console.log(url);
    return (dispatch) => {
        dispatch(authStart());
        axios.post(url, {
            ...authData
        })
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                dispatch(changePasswordFail());
            }
            else if (response.data === 'success'){
                dispatch(changePasswordSuccess());
            }
            
        })
        .catch((error) => {
            console.log(error);
            dispatch(authError(error));
        });
    };
}

export const resetChangePassword = () => {
    return (dispatch) => {
        dispatch(changePasswordFail());
    }
}

export const resetRecoverPassword = () => {
    return (dispatch) => {
        dispatch(recoverPasswordFail());
    }
}